import axios from "axios";
import cookieUtils from "../../util/cookieUtils";

export default {
    state: () => ({
        agencyPaymentOutlines: null,
        agencyPayments: null,
        selectedAgencyPayment: null,
        selectedAgencyOutline: null,
        updateProcess:false,
        agencyProformas: null,
        sailAgencyProformaStatusList: null
    }),
    mutations: {
        setAgencyPaymentOutlines(state, agencyPaymentOutlines){
            state.agencyPaymentOutlines = agencyPaymentOutlines;
        },
        setAgencyPayments(state, agencyPayments){
            state.agencyPayments = agencyPayments;
        },
        setSelectedAgencyOutline(state, selectedAgencyOutline){
            state.selectedAgencyOutline = selectedAgencyOutline;
        },
        setUpdateProcess(state, updateProcess){
            state.updateProcess = updateProcess;
        },
        setSelectedAgencyPayment(state, selectedAgencyPayment){
            state.selectedAgencyPayment = selectedAgencyPayment;
        },
        setAgencyProformas(state, agencyProformas){
            state.agencyProformas = agencyProformas;
        },
        setSailAgencyProformaStatusList(state, sailAgencyProformaStatusList){
            state.sailAgencyProformaStatusList = sailAgencyProformaStatusList;
        }
    },
    getters: {
        getAgencyPaymentOutlines: state => {
            return state.agencyPaymentOutlines;
        },
        getAgencyPayments: state => {
            return state.agencyPayments;
        },
        getSelectedAgencyOutline: state => {
            return state.selectedAgencyOutline;
        },
        getUpdateProcess: state => {
            return state.updateProcess;
        },
        getSelectedAgencyPayment: state => {
            return state.selectedAgencyPayment;
        },
        getAgencyProformas: state => {
            return state.agencyProformas;
        },
        getSailAgencyProformaStatusList: state => {
            return state.sailAgencyProformaStatusList;
        },
    },
    actions: {
        loadAgencyPaymentOutlines : (context) => {
            const headers = {
                "Authorization": "Bearer " + context.getters.getToken.token,
            };

            return axios.get(context.getters.getServiceUrl + "/admin-api/agency-payments/outline", {headers})
                .then((response) => {
                    response.data.sort((a, b) => {
                        return ((a.spendTotal - a.paidTotal) < (b.spendTotal - b.paidTotal)) ? 1 : -1
                    });

                    context.commit("setAgencyPaymentOutlines", response.data);
                    return response.data;
                })
        },
        loadAgencyPaymentByAgencyId : (context, request) => {
            const headers = {
                "Authorization": "Bearer " + context.getters.getToken.token,
            };
            return axios.get(context.getters.getServiceUrl + "/admin-api/agency-payments/by-agency/"+ request.id, {headers})
                .then((response) => {
                    context.commit("setAgencyPayments", response.data);
                    return response.data;
                })
        },
        createAgencyPayment : (context, request) => {
            const headers = {
                "Authorization": "Bearer " + context.getters.getToken.token,
            };

            return axios.post(context.getters.getServiceUrl + "/admin-api/agency-payments", request,{headers})
                .then((response) => {
                    return response.data;
                })
        },

        updateAgencyPayment: (context, request) => {
            const headers = {
                "Authorization": "Bearer " + context.getters.getToken.token,
            };

            return axios.put(context.getters.getServiceUrl + "/admin-api/agency-payments", request,{headers})
                .then((response) => {
                    return response.data;
                })
        },

        deleteAgencyPayment: (context, request) => {
            const headers = {
                "Authorization": "Bearer " + context.getters.getToken.token,
            };

            return axios.delete(context.getters.getServiceUrl + "/admin-api/agency-payments/"+ request.id,{headers})
                .then((response) => {
                    return response.data;
                })
        },
        loadAgencyProformas: (context, request) => {
            const headers = {
                "Authorization": "Bearer " + context.getters.getToken.token,
            };

            return axios.get(context.getters.getServiceUrl + "/admin-api/proforma", {headers})
                .then((response) => {
                    context.commit("setAgencyProformas", response.data);
                    return response.data;
                })
        },
        loadAgencyProformaInvoices: (context) => {
            const headers = {
                "Authorization": "Bearer " + context.getters.getToken.token,
            };

            return axios.get(context.getters.getServiceUrl + "/admin-api/invoice/proforma-invoices", {headers})
                .then((response) => {
                    return response.data;
                })
        },
        loadSailAgencyProformaStatusList: (context, request) => {
            const headers = {
                "Authorization": "Bearer " + context.getters.getToken.token,
            };

            return axios.get(context.getters.getServiceUrl + "/admin-api/proforma/sail/"+request.sailId, {headers})
                .then((response) => {
                    context.commit("setSailAgencyProformaStatusList", response.data);
                    return response.data;
                })
        },
        downloadProforma: (context, request) => {
            const headers = {
                "Authorization": "Bearer " + context.getters.getToken.token,
            };

            return axios.get(context.getters.getServiceUrl + "/admin-api/proforma/document/"+request.id, {headers, responseType: 'arraybuffer'})
                .then((response) => {
                    const url = window.URL.createObjectURL(new Blob([response.data]));
                    const link = document.createElement('a');
                    link.href = url;
                    link.setAttribute('download', 'proforma.xls'); //or any other extension
                    document.body.appendChild(link);
                    link.click();
                    return response.data;
                })
        },
        downloadProformaByProformaInvoiceId: (context, request) => {
            const headers = {
                "Authorization": "Bearer " + context.getters.getToken.token,
            };

            return axios.get(context.getters.getServiceUrl + "/admin-api/proforma/document/by-invoice-id/"+request.id, {headers, responseType: 'arraybuffer'})
                .then((response) => {
                    const url = window.URL.createObjectURL(new Blob([response.data]));
                    const link = document.createElement('a');
                    link.href = url;
                    link.setAttribute('download', 'proforma.xls'); //or any other extension
                    document.body.appendChild(link);
                    link.click();
                    return response.data;
                })
        },
        downloadInvoice: (context, request) => {
            const headers = {
                "Authorization": "Bearer " + context.getters.getToken.token,
            };

            return axios.get(context.getters.getServiceUrl + "/admin-api/invoice/document/"+request.id, {headers, responseType: 'arraybuffer'})
                .then((response) => {
                    const url = window.URL.createObjectURL(new Blob([response.data]));
                    const link = document.createElement('a');
                    link.href = url;
                    link.setAttribute('download', 'invoice.xls'); //or any other extension
                    document.body.appendChild(link);
                    link.click();
                    return response.data;
                })
        },
        downloadSailReport: (context, request) => {
            const headers = {
                "Authorization": "Bearer " + context.getters.getToken.token,
            };

            return axios.get(context.getters.getServiceUrl + "/admin-api/sail/sailReport/download", {headers, responseType: 'arraybuffer'})
                .then((response) => {
                    const url = window.URL.createObjectURL(new Blob([response.data]));
                    const link = document.createElement('a');
                    link.href = url;
                    link.setAttribute('download', 'sail-report.xls'); //or any other extension
                    document.body.appendChild(link);
                    link.click();
                    return response.data;
                })
        },
        generateProforma: (context, request) => {
            const headers = {
                "Authorization": "Bearer " + context.getters.getToken.token,
            };

            return axios.get(context.getters.getServiceUrl + "/admin-api/proforma/generate?agencyId="+request.agencyId+"&sailId="+request.sailId,
                {headers})
                .then((response) => {
                    return response.data;
                })
        },
        generateInvoiceTL: (context, request) => {
            const headers = {
                "Authorization": "Bearer " + context.getters.getToken.token,
            };

            return axios.get(context.getters.getServiceUrl + "/admin-api/invoice/generate/tl?agencyId="+request.agencyId+"&sailId="+request.sailId,
                {headers})
                .then((response) => {
                    return response.data;
                })
        },
        generateInvoiceEUR: (context, request) => {
            const headers = {
                "Authorization": "Bearer " + context.getters.getToken.token,
            };

            return axios.get(context.getters.getServiceUrl + "/admin-api/invoice/generate/eur?agencyId="+request.agencyId+"&sailId="+request.sailId,
                {headers})
                .then((response) => {
                    return response.data;
                })
        },
        loadProformaDetailed: (context, id) => {
            const headers = {
                "Authorization": "Bearer " + context.getters.getToken.token,
            };

            return axios.get(context.getters.getServiceUrl + "/admin-api/proforma/"+id+"/detailed",
                {headers})
                .then((response) => {
                    return response.data;
                })
        },
        cancelInvoice: (context, id) => {
            const headers = {
                "Authorization": "Bearer " + context.getters.getToken.token,
            };

            return axios.get(context.getters.getServiceUrl + "/admin-api/invoice/cancel/"+id,
                {headers})
                .then((response) => {
                    return response.data;
                })
        },
        generateInvoiceFromProforma: (context, id) => {
            const headers = {
                "Authorization": "Bearer " + context.getters.getToken.token,
            };

            return axios.get(context.getters.getServiceUrl + "/admin-api/invoice/generate/by-proforma/"+id,
                {headers})
                .then((response) => {
                    return response.data;
                })
        },
        payInvoice: (context, request) => {
            const headers = {
                "Authorization": "Bearer " + context.getters.getToken.token,
            };

            return axios.post(context.getters.getServiceUrl + "/admin-api/invoice/pay", request,
                {headers})
                .then((response) => {
                    return response.data;
                })
        }
    }
}

